import { useEffect } from "react";
import { io } from "socket.io-client";
import { behaviorTimerClient } from "src/shared/util/src/behavior-timers/client";
import { behaviorTimerSocketTransport } from "src/shared/util/src/behavior-timers/socket-transport";

/** One host per runtime page; timer consumers share its client and interpolation loop. */
export function useBehaviorTimerHost(
  meetId: string,
  serverUrl?: string,
  token?: string,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled || !serverUrl || !meetId) return;
    const socket = io(serverUrl, {
      transports: ["websocket"],
      query: { clientType: "WEBAPP" },
      auth: token ? { accessToken: token } : undefined,
    });
    const cleanup = behaviorTimerClient.configure(
      behaviorTimerSocketTransport(socket, meetId),
    );
    return () => {
      cleanup();
      socket.disconnect();
    };
  }, [enabled, meetId, serverUrl, token]);
}
